import { handleActions } from 'redux-actions';

import { lanList, lanData } from 'util/i18n';

export default handleActions(
	{
		CHANGE_LANGUAGE: (state, action) => ({
			...state,
			lan: action.payload.lan,
		}),

		MATCH_MEDIA: (state, action) => ({
			...state,
			window: {
				...state.window,
				media: action.payload.media,
			},
		}),

		SCROLL_WINDOW: (state, action) => ({
			...state,
			window: {
				...state.window,
				pageYOffset: action.payload.pageYOffset,
			},
		}),

		STORE_PAGE: (state, action) => ({
			...state,
			page: action.payload.page,
		}),

		GET_COOKIES: (state, action) => ({
			...state,
			cookies: action.payload.cookies,
		}),

		ACCEPT_COOKIES: (state, action) => ({
			...state,
			cookies: {
				...state.cookies,
				...action.payload.cookies,
			},
		}),
	},
	{
		lan: 'zh-TW',
		lanList: lanList.filter(lan => lanData[lan]),
		lanData,
		window: {
			media: '',
			pageYOffset: 0,
		},
		page: 'main',
		cookies: {},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/global.js